export default "__VITE_ASSET__Dm6Bl3x2__"